import * as actions from "../actions/actionTypes";

const initialState = {
  data: null,
  meta: null,
  loading: false,
  loaded: false,
  refreshing: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.LOAD_USAGE_TABLE_START:
      const { refreshing } = action;
      return {
        ...state,
        loading: !refreshing,
        refreshing: true,
      };

    case actions.LOAD_USAGE_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        meta: action.meta,
        loaded: true,
        refreshing: false,
      };

    case actions.LOAD_USAGE_TABLE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        refreshing: false,
        error: action.error,
      };

    default:
      return state;
  }
};
